import { type MutationKey, type QueryKey, useQueryClient } from "@tanstack/react-query";
import { onAdvancingSessionActivity } from "common/signalR";
import { useEffect } from "react";

interface Options {
  // The page's own mutation already refetches, and its activity arrives before the mutation finishes
  skipWhileMutating?: MutationKey
}

export const useInvalidateOnAdvancingActivity = (advancingSessionId: number, queryKey: QueryKey, options?: Options) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const { removeEvent } = onAdvancingSessionActivity(activity => {
      if (activity.itemId !== advancingSessionId) return;
      if (options?.skipWhileMutating && queryClient.isMutating({ mutationKey: options.skipWhileMutating }) > 0) return;
      queryClient.invalidateQueries({ queryKey });
    });

    return removeEvent;
  }, [advancingSessionId]);
};
